import { envIsProduction } from "common/common";

export function wsUrlGet(): string {
  let url = "";
  if (!envIsProduction()) {
    url = "ws://localhost:3015";
  } else {
    url = "wss://sakusas.emlearn.info/ws";
  }
  return url;
}
